import { useSelector } from "react-redux";
import { addToCart } from "../../redux/slices/cart/cartSlice";
import ProductImages from "../ProductDetails/ProductImages";
import ProductInfo from "../ProductDetails/ProductInfo";
import { dispatch, RootState } from "../../redux/store";
import { useEffect, useMemo, useState } from "react";
import Loader from "./Loader";
import DefaultImage from "../../assets/png/defaultImage.png";
import { getProductById } from "../../redux/slices/Products/productSlice";
import { set } from "react-hook-form";

const ProductDetailsModal = ({
  home,
  image,
  id,
  setIsModalOpen,
  isModalOpen,
}: {
  home: boolean;
  image: any;
  id: number;
  // setQty: any;
  // qty: number;
  // setSelectedVariable: any;
  // selectedVariable: any;
  setIsModalOpen: any;
  isModalOpen: boolean;
}) => {
  const { isProductLoading, product } = useSelector(
    (state: RootState) => state.product
  );
  const { selectedBusinessLocation } = useSelector(
    (state: RootState) => state.businessLocation
  );
  const { selectedCartItem } = useSelector((state: RootState) => state.cart);
  const [qty, setQty] = useState(1);

  useMemo(() => {
    dispatch(getProductById(id, selectedBusinessLocation?.id));
  }, [id]);

  return (
    <>
      {isProductLoading ? (
        <div className="w-full flex justify-center items-center">
          <Loader />
        </div>
      ) : (
        <div className="w-full px-5 py-2">
          <div className="py-6 flex flex-col lg:self-center lg:flex-row lg:justify-center gap-3 w-full max-w-[1200px]">
            <ProductImages
              home={home}
              images={image?.length > 0 ? image : []}
            />
            <ProductInfo
              id={id}
              setQty={setQty}
              qty={qty}
              variant={product}
              setModal={setIsModalOpen}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ProductDetailsModal;
